import React from 'react';

import callModel from 'src/components/call/model';
import BaseComponent from 'src/components/BaseComponent';
import { popupModel } from 'src/components/complex';

import { isAdminPage, permissions, userFullName, lang } from 'src/helpers';

import model from './model';

import chatModel from 'src/components/messages/chat/model';
import ChatTicketPopup from 'src/components/messages/chat/ChatTicketPopup';
import timelineModel from './timelineModel';
import ProfilePopup, { FreeChatForContact } from './ProfilePopup';
import { RadioField, SearchTextField } from 'src/components/basic';
import treatmentsModel from './treatmentsModel';
import analysesModel from './analysesModel';
import AlertManager from 'src/components/alert/AlertManager';
import LANG_CONST from 'src/helpers/lang/const';

const { PAGES } = permissions;
export const tabs = [
  { id: 'chat', name: 'Chat' },
  { id: 'analyses', name: 'Analyses' },
  { id: 'treatment', name: 'Treatment' },
  { id: 'timeline', name: 'Diary' }
];

export const list = [
  { component: FreeChatForContact, isShow: (contactUser, user) => user?.isDoctor },
  {
    label: 'Archive',
    isShow: (contact) => contact && !contact.archive,
    onClick: (contact) => model.setArchive(contact.partnerId, true)
  },
  {
    label: 'Unarchive',
    isShow: (contact) => contact && contact.archive,
    onClick: (contact) => model.setArchive(contact.partnerId, false)
  },
  {
    label: 'Remove',
    isShow: () => true,
    onClick: (contact) => {
      let name = userFullName(contact.partnerProfile || contact);
      let isDoctor = model.getState().profile?.isDoctor;
      AlertManager.popup(AlertManager.TYPES.WARN, {
        title: lang.t(LANG_CONST.notice.delete_all_messages, { name }),
        close: false,
        maxWidth: 370,
        body: ({ dataForm, setDataForm }) => {
          return isDoctor ? null : (
            <div className={'mc-flex'}>
              <RadioField
                template={'2'}
                checked={!!dataForm.isRemoveAll}
                onClick={(e) => {
                  e.preventDefault();
                  setDataForm({ isRemoveAll: !dataForm.isRemoveAll });
                }}
                onChange={() => {}}
                label={lang.t(LANG_CONST.text.also_delete_for_name, { name })}
              />
            </div>
          );
        },
        actionButton: {
          label: LANG_CONST.buttons.yes,
          action: ({ hide, dataForm }) => {
            model.handleRemove({
              partnerId: contact.partnerId || contact.partnerProfile?.id || contact.id,
              forBoth: !!dataForm.isRemoveAll
            });
            hide();
          }
        },
        cancelButton: {
          label: LANG_CONST.buttons.no,
          action: (props) => {
            props.hide();
          }
        }
      });
    }
  }
];

export class BaseMessage extends BaseComponent {
  constructor(props) {
    super(props);
    if (props.router.location?.state?.tab) {
      model.changeMessageTab({ id: props.router.location?.state.tab });
    }
    this.rightSliderRef = React.createRef();
  }

  componentDidMount() {
    model.setStateSilent({ hideInfo: true, isFocus: true });
    model.subscribe(this.subscription);
    callModel.subscribe(this.subscription);
    model.on('contact_refresh', this.onContactRefresh);
    timelineModel.baseSubscribe(this.subscription);
    this.openRouteContact();
    model.on('switchAccount', this.onSwitchAccount);
    model.on('closeContact', this.onCloseContact);
    if (this.rightSliderRef.current) this.rightSliderRef.current.style.display = 'none';
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    callModel.unsubscribe(this.subscription);
    timelineModel.unsubscribe(this.subscription);
    model.cancel('contact_refresh', this.onContactRefresh);
    model.cancel('switchAccount', this.onSwitchAccount);
    model.cancel('closeContact', this.onCloseContact);
    model.setStateSilent({ isFocus: false });
  }

  onCloseContact = () => {
    this.navigate(isAdminPage() ? PAGES.ADMIN_MESSAGES_PAGE.path : PAGES.MESSAGES_PAGE.path);
  };

  onSwitchAccount = () => {
    model.setStateSilent({ waitingOpenLast: true });
  };

  openRouteContact = () => {
    let routeContactId = this.props.router.params.id || model.state.active;
    if (routeContactId) {
      model.openId(routeContactId);
    } else {
      this.openLast();
    }
  };

  openLast = () => {
    let lastContact = model.items('recent')[0];
    if (lastContact) {
      model.openId(lastContact.partnerId);
      setTimeout(() => {
        this.navigate(
          isAdminPage()
            ? PAGES.ADMIN_MESSAGES_USER_PAGE.match(lastContact.partnerId)
            : PAGES.MESSAGES_USER_PAGE.match(lastContact.partnerId)
        );
      }, 1);
    } else if (model.getApiState('refresh').loading) {
      model.setStateSilent({ waitingOpenLast: true });
    }
  };

  onContactRefresh = () => {
    if (model.state.waitingOpenLast) {
      model.setStateSilent({ waitingOpenLast: false });
      this.openLast();
    }
  };

  setOption = (item) => {
    switch (item.label) {
      case 'Block':
        break;
      default:
        break;
    }
  };
  startCall = () => {
    if (chatModel.isChatAvailable()) {
      model.emit('startCall', { video: true, partner: model.state.contactUser });
    } else {
      popupModel.setActivePopup('chat_ticket_popup', {
        active: true,
        component: ChatTicketPopup
      });
    }
  };

  toggleSearch = () => {
    const enable = !model.state.enableSearch;

    model.setState({ enableSearch: enable });
  };

  viewProfile = (subpage) => {
    let contactUser = model.state.contactUser;
    let url = PAGES.DOCTORS_DETAIL_PAGE.match(contactUser?.username);
    if (contactUser.isDoctor) {
      model.emit('openDoctor', contactUser);
      if (subpage && !model.state.user?.isDoctor) url += '/' + subpage;
    } else {
      url = PAGES.PATIENTS_DETAIL_PAGE.match(contactUser?.id);
    }
    this.navigate(url);
  };

  profilePopup = () => {
    popupModel.setActivePopup('profile_popup', {
      active: true,
      component: ProfilePopup
    });
  };

  openRightSlide = () => {
    model.setState({ hideInfo: false });
    this.rightSliderRef.current.style.display = 'block';
  };
  closeRightSlide = () => {
    model.setState({ hideInfo: true });
    setTimeout(() => {
      this.rightSliderRef.current.style.display = 'none';
    }, 300);
  };

  renderSearchMessage = () => {
    return (
      <SearchTextField
        placeholder={
          'Search in ' +
          model.getTab('main_message') +
          (model.getTab('main_message') === 'treatment' ? 's' : '')
        }
        onChange={(t) => {
          model.listHandleChange('search_chat', t);
          switch (model.getTab('main_message')) {
            case 'chat':
              chatModel.handleChangeSearch(t);
              break;
            case 'treatment':
              treatmentsModel.handleChangeSearch(t);
              break;
            case 'analyses':
              analysesModel.handleChangeSearch(t);
              break;
            case 'timeline':
              timelineModel.handleChangeSearch(t);
              break;
            default:
              break;
          }
        }}
        hideSearchFn={this.toggleSearch}
        value={model.listInput('search_chat')}
      />
    );
  };
}

export default BaseMessage;
